import { createSelector } from 'reselect'
import { getCurrentFinancialAccountId } from 'selectors'
import { getContactsWithRelationships } from 'selectors/onboarding/contactRelationships'

export const getContactsState = state => state.contacts
export const getContactFinancialAccountRolesState = state => state.contactFinancialAccountRoles
export const getProspectState = state => state.prospect.prospect

export const getFinancialAccountContacts = (contacts, contactRoles, financialAccountId) => (
  contactRoles
    .filter(currentContactRole =>
      currentContactRole.financialAccountId === financialAccountId)
    .map((currentContactRole) => {
      const contact = contacts.find(c =>
        c.id === currentContactRole.contactId)
      if (!contact) return null
      const {
        contactId,
        ...newCurrentContactRole
      } = currentContactRole

      return {
        ...newCurrentContactRole,
        ...contact,
        contactFinancialAccountRoleId: currentContactRole.id,
      }
    })
    .filter(c => !!c)
)

export const getCurrentFinancialAccountContacts = createSelector(
  getContactsWithRelationships,
  getContactFinancialAccountRolesState,
  getCurrentFinancialAccountId,
  (allContacts, contactRolesState, financialAccountId) => {
    const { contactFinancialAccountRoles } = contactRolesState
    return getFinancialAccountContacts(
      allContacts, contactFinancialAccountRoles, financialAccountId)
  }
)

export const getCurrentContacts = createSelector(
  getContactsState,
  getContactFinancialAccountRolesState,
  getProspectState,
  (allContacts, allContactRoles, prospect) => {
    const { contacts } = allContacts
    const { contactFinancialAccountRoles } = allContactRoles

    const roleContactIds = contactFinancialAccountRoles.map(r => r.contactId)

    return contacts.filter(c => roleContactIds.includes(c.id) || c.id === prospect.personContactId)
  }
)

export default {
  getCurrentFinancialAccountContacts,
  getCurrentContacts
}



// WEBPACK FOOTER //
// ./src/selectors/onboarding/contactRoles.js